WatchSumo.MonthlyAvailability = class MonthlyAvailability extends WatchSumo.WeeklyAvailability {
};